import { Home, LucideIcon, Phone, Route, Users } from 'lucide-react';

export type IMenu = {
  text: string;
  link: string;
  icon?: LucideIcon;
  footer: boolean;
  header: boolean;
  hideItemsOnHeader?: boolean;
  items: {
    text: string,
    link: string,
    external?: boolean
  }[];
}

export const CustomHeaderPaths = ['/'];

export const MENU: IMenu[] = [
  {
    text: 'Home',
    link: '/',
    icon: Home,
    footer: false,
    header: true,
    items: []
  },
  {
    text: 'Branche',
    link: '/branche',
    icon: Route,
    footer: true,
    header: true,
    items: [
      {text: 'L/C', link: '/branche/lc'},
      {text: 'E/G', link: '/branche/eg'},
      {text: 'R/S', link: '/branche/rs'},
      {text: 'Comunità Capi', link: '/branche/comunita-capi'}
    ]
  },
  {
    text: 'Gruppo',
    link: '/gruppo',
    icon: Users,
    footer: false,
    header: true,
    items: []
  },
  {
    text: 'Contatti',
    link: '/contatti',
    icon: Phone,
    footer: true,
    header: true,
    hideItemsOnHeader: true,
    items: [
      {
        text: 'Contattaci',
        link: '/contatti'
      },
      {
        text: 'scoutacireale.6@gmail.com',
        link: 'mailto:scoutacireale.6@gmail.com',
        external: true
      },
      {
        text: 'Instagram',
        link: 'https://www.instagram.com/agesci_acireale_6/?hl=it',
        external: true
      },
      {
        text: 'Cooperativa La Nuova Zagara',
        link: 'https://lanuovazagara.it/',
        external: true
      }
    ]
  }
];